import { PickAndChooseCtaState } from '../models';
export const buildInitialSelections = segmentAvailabilities => segmentAvailabilities.map(segment => {
  var _segment$boundIndex, _segment$segmentIndex, _segment$price$price$, _segment$price, _segment$departureAir, _segment$arrivalAirpo, _segment$flightNumber, _segment$loungeInfo;
  const available = Boolean(segment.available);
  return {
    customerBoundIndex0Based: (_segment$boundIndex = segment.boundIndex) !== null && _segment$boundIndex !== void 0 ? _segment$boundIndex : 0,
    customerSegmentIndex0Based: (_segment$segmentIndex = segment.segmentIndex) !== null && _segment$segmentIndex !== void 0 ? _segment$segmentIndex : 0,
    available,
    selected: available,
    displayPriceRaw: (_segment$price$price$ = (_segment$price = segment.price) === null || _segment$price === void 0 || (_segment$price = _segment$price.price) === null || _segment$price === void 0 ? void 0 : _segment$price.value) !== null && _segment$price$price$ !== void 0 ? _segment$price$price$ : 0,
    departureAirport: (_segment$departureAir = segment.departureAirport) !== null && _segment$departureAir !== void 0 ? _segment$departureAir : '',
    arrivalAirport: (_segment$arrivalAirpo = segment.arrivalAirport) !== null && _segment$arrivalAirpo !== void 0 ? _segment$arrivalAirpo : '',
    flightNumber: (_segment$flightNumber = segment.flightNumber) !== null && _segment$flightNumber !== void 0 ? _segment$flightNumber : '',
    loungeInfo: (_segment$loungeInfo = segment.loungeInfo) !== null && _segment$loungeInfo !== void 0 ? _segment$loungeInfo : null
  };
});
export const getActiveSelections = segments => segments.filter(s => s.available && s.selected);
export const getSelectedCount = segments => getActiveSelections(segments).length;
export const segmentKey = s => `${s.customerBoundIndex0Based}-${s.customerSegmentIndex0Based}-${s.departureAirport}-${s.arrivalAirport}`;
export const hasSelectionChanged = (draft, baseline) => {
  const draftKeys = new Set(getActiveSelections(draft).map(segmentKey));
  const baselineKeys = new Set(getActiveSelections(baseline).map(segmentKey));
  return draftKeys.size !== baselineKeys.size || [...draftKeys].some(k => !baselineKeys.has(k));
};
export const getAvailableCount = segments => segments.filter(s => s.available).length;
export const isSingleSegment = segments => getAvailableCount(segments) === 1;
export const getTotalDisplayPrice = segments => getActiveSelections(segments).reduce((sum, s) => sum + s.displayPriceRaw, 0);
export const getFromDisplayPrice = segments => {
  const prices = segments.filter(s => s.available).map(s => s.displayPriceRaw);
  return prices.length ? Math.min(...prices) : 0;
};
export const deriveCtaState = ({
  saved,
  segments
}) => {
  if (!saved) {
    return PickAndChooseCtaState.Select;
  }
  return getSelectedCount(segments) > 0 ? PickAndChooseCtaState.Edit : PickAndChooseCtaState.Zero;
};
export const toSelectionInput = segments => getActiveSelections(segments).map(({
  customerBoundIndex0Based,
  customerSegmentIndex0Based
}) => ({
  customerBoundIndex0Based,
  customerSegmentIndex0Based
}));
export const toPassValue = (segments, saved, cartBreakDown = null) => ({
  value: getSelectedCount(segments) > 0,
  priceRaw: getTotalDisplayPrice(segments),
  saved,
  segments,
  cartBreakDown
});
export const toggleSegment = (segments, index) => segments.map((s, i) => i === index && s.available ? {
  ...s,
  selected: !s.selected
} : s);
export const deselectAll = segments => segments.map(s => ({
  ...s,
  selected: false
}));
//# sourceMappingURL=segmentSelection.js.map